module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Medium-Hestia.36efd26.otf";